import React from "react";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { InputNoticeList } from "./input-notice-list";

import type { InputProps, PathProps } from "./types";

type ListInputProps<
  T extends React.FC<Omit<Parameters<T>[0], "basePath"> & PathProps>,
> = {
  label: string;
  boldLabel?: boolean;
  required?: boolean;
  mb?: number;
  component: T;
  componentProps: (Omit<Parameters<T>[0], "basePath"> & {
    disabled?: boolean;
  })[];
  onPush: () => void;
  onRemove: (index: number) => void;
  maxLength?: number;
  disabled?: Parameters<T>[0] extends InputProps ? boolean : undefined;
} & {
  notices?: Parameters<typeof InputNoticeList>[0]["notices"];
} & PathProps;

export const ListInput: <
  T extends React.FC<Omit<Parameters<T>[0], "basePath"> & PathProps>,
>(
  props: ListInputProps<T>,
) => JSX.Element = (props) => {
  const {
    label,
    boldLabel = true,
    required = false,
    mb = 6,
    component,
    componentProps,
    basePath,
    onPush,
    onRemove,
    disabled = false,
    maxLength,
    notices,
  } = props;
  return (
    <div className={`field mb-${mb}`}>
      <FormFieldLabel label={label} bold={boldLabel} required={required} />
      {Array.isArray(notices) && notices.length > 0 && (
        <InputNoticeList notices={notices} />
      )}
      {componentProps.map((p, i) => {
        const path = [...basePath, i];
        return (
          <div key={path.join("-")}>
            {!disabled && (
              <div
                style={{ position: "relative" }}
                onClick={() => {
                  onRemove(i);
                }}
              >
                <span className="icon pl-5" style={{ position: "absolute" }}>
                  <i className="fas fa-window-close"></i>
                </span>
              </div>
            )}

            <div
              className="my-2 ml-2 pl-5"
              style={{ borderLeft: "0.25rem solid silver" }}
            >
              {component({
                ...p,
                basePath: path,
                disabled: "disabled" in p ? p.disabled : disabled,
              })}
            </div>
          </div>
        );
      })}
      {disabled || (maxLength && componentProps.length >= maxLength) ? null : (
        <div className="ml-2">
          <button className="button is-fullwidth" onClick={onPush}>
            <span className="icon has-text-dark">
              <i className="fas fa-plus"></i>
            </span>
          </button>
        </div>
      )}
    </div>
  );
};
